import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IGetStaffAndRoomsData } from '../types';

export const GET_STAFF_AND_ROOMS: TypedDocumentNode<IGetStaffAndRoomsData> = gql`
  query getStaffAndRooms {
    viewer {
      id
      site {
        id
        rooms {
          capacity
          created
          groupTypes
          id
          staff {
            id
            lastName
            firstName
            role
            username
          }
          status
          title
          updated
        }
        staff {
          active
          confirmed
          email
          firstName
          id
          lastName
          phone
          role
          room {
            id
            title
          }
          username
          welcomed
        }
      }
    }
  }
`;
